import { createFileRoute } from "@tanstack/react-router";

import privacyPolicyHtml from "@/content/privacy-policy.html?raw";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/privacy-policy")({
  head: () => ({
    meta: [{ title: "CBVA Privacy Policy" }],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DefaultLayout
      classNames={{
        content: "py-12 px-4 max-w-3xl mx-auto",
      }}
    >
      <div
        className="prose max-w-none"
        // biome-ignore lint/security/noDangerouslySetInnerHtml: static HTML file we control
        dangerouslySetInnerHTML={{ __html: privacyPolicyHtml }}
      />
    </DefaultLayout>
  );
}
